import { Card } from './Card'
import { XAxis, YAxis, Tooltip, ResponsiveContainer, AreaChart, Area } from 'recharts'

export const Turnover = ({ data, isLoading, filter, onSubmitFilter }) => {
    return (
        <Card
            isLoading={isLoading}
            title='Turnover'
            filterTitle='Filter Turnover'
            initFilter={filter}
            onSubmitFilter={onSubmitFilter}
        >
            <div className='relative w-full h-full'>
                <ResponsiveContainer style={{ height: 'auto', paddingBottom: 35, marginLeft: -20 }}>
                    <AreaChart data={data}>
                        <XAxis dataKey='month' tick={{ fontSize: 10 }} />
                        <YAxis tick={{ fontSize: 10 }} />
                        <Tooltip
                            formatter={(value, name, props) => {
                                const count = props?.payload?.resigned_count
                                return `${value}% (${count})`
                            }}
                        />
                        <Area
                            type='monotone'
                            name='Turnover'
                            dataKey='turnover_rate'
                            stroke='#0ea5e9'
                            strokeWidth={3}
                            fill='#0ea5e933'
                        />
                    </AreaChart>
                </ResponsiveContainer>

                {!data?.length && (
                    <div className='absolute inset-0 flex items-center justify-center font-semibold text-neutral-60'>
                        Data Not Available
                    </div>
                )}
            </div>
        </Card>
    )
}
